export const COMPLEX_PASSWORD_VALIDATION_MESSAGE = "Password must be at least 12 characters long and include a mix of uppercase and lowercase letters, numbers, and special characters. No character should be repeated more than twice.";
